import React, { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import TabsClassic from "src/components/TabsClassic";
import { classResponsiveFormDoubleWidth, optionsYesNoResponse, optionsEstadosSelect, ERRORFIELDREQUIRED } from "src/data/ConstantForm";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import ContainerSectionModal from "src/components/ContainerSectionModal";
import SelectForm from "src/components/ComponentesFormularios/SelectForm";
import { CalendarFormRange } from "src/components/ComponentesFormularios/CalendarForm";
import Zoom from 'react-medium-image-zoom';
import {useDropzone} from 'react-dropzone';
import { useDispatch } from "react-redux";
import { productosService } from "src/services/unoauno/apiProductos";
import { GlobalConstants } from "src/data/GlobalConstants";
import TimeForm from "src/components/ComponentesFormularios/TimeForm";
import { getCurrentTime, validArray } from "src/util/functions";
import CheckBox from "src/components/ComponentesFormularios/CheckBox";
import "./styles.css"

const BASE_STYLE = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderBottom: "2px dashed #2196f3",
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const ACTIVE_STYLE = {
    borderColor: '#2196f3'
};

const ACCEPT_STYLE = {
    borderColor: '#00e676'
};

const REJECT_STYLE = {
    borderColor: '#ff1744'
};

const DIVINFO = {
    display: 'flex',
    width: "35px",
    height: "35px",
    opacity: 0.2,
    borderRadius: "100%",
    boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .6)"
};

const ICONINFO = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: "1.2rem"
}

const InformacionGeneral = ({ data: { dataProducto, segmentacionesProveedores, categorias, marcas, categorizacion, tags }, stateTab, showHelp, setShowHelp }) => {    
    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="w-100 px-2">
                <div className={`containerMessageHelpPro boxShadow ${showHelp ? "containerHelpProOpen" : ""}`} style={{ backgroundColor: Colors.BLUE_LOW }}>
                    {stateTab == 1 ? 
                        <span>Los campos que se modifiquen en este apartado se verán reflejados en todos los productos que tengan asignado como código de producto <strong className="ml-2">{dataProducto.idProducto}</strong>.</span> 
                    : 
                        <span>Los campos que se modifiquen en este apartado se verán reflejados solo en el producto actualmente seleccionado.</span>}
        
                    <div>
                        <button onClick={() => setShowHelp(false)}>
                            <i style={{color: Colors.COLOR_AMOVIL_BLUE_DARK}} className="far fa-times fa-1x"/>
                        </button>
                    </div>
                </div>

                <ContainerSectionModal label="Información Básica" 
                    component={
                        <InformacionBasicaGeneralComponent
                            tags={tags}
                            dataProducto={dataProducto}
                            segmentacionesProveedores={segmentacionesProveedores}
                        />
                    }/>
                <ContainerSectionModal label="Categorias y Marcas" 
                    component={
                        <CategoriasYMarcasComponent 
                            dataProducto={dataProducto}
                            categorias={categorias}
                            marcas={marcas}
                            categorizacion={categorizacion}
                        />
                    }/>
                <ContainerSectionModal label="Restricciones de compra" 
                    component={
                        <RestriccionesDeCompraComponent 
                            dataProducto={dataProducto}
                            stateTab={stateTab}
                        />
                    }/>
                <ContainerSectionModal label="Imágenes" 
                    component={
                        <ImagenesComponent 
                            dataProducto={dataProducto}
                        />
                    }/>
            </div>
        </div>
    )
}

const InformacionBasicaGeneralComponent = ({segmentacionesProveedores = [], tags = [], dataProducto}) => {
    const dispatch = useDispatch();
    const methods = useForm({
        defaultValues: {
            nombre: dataProducto.nombreProducto,
            orden: dataProducto.orden,
            segmentacion: dataProducto.segmentoCliente,
            evento: dataProducto.evento,
            descripcion: dataProducto.descripcion,
        }
    });

    const [palabraInput, setPalabraInput] = useState('')
    const [palabras, setPalabras] = useState(tags)
    const { control, setValue, handleSubmit, formState: { errors }, register } = methods;

    const onClickAgregar = () => {
        if(palabraInput != '' && !palabras.find(item => item.palabraClave.toUpperCase() == palabraInput.toUpperCase())){
            setPalabras([...palabras, { palabraClave: palabraInput }])
            setPalabraInput('')
        }
    }

    const onClickEliminar = (palabra) => {
        setPalabras(palabras.filter(item => item.palabraClave != palabra))
    }

    const onSubmit = async (data) => {
        try {
            await productosService.updateInformacionBasicaGeneral({idProducto: dataProducto.idProducto, data, palabras: palabras.map(item => item.palabraClave)})
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Información actualizada correctamente' } });
        } catch(error){
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    }

    return (
        <FormProvider {...methods}>
            <div className="w-100 row m-0 position-relative">
                <InputForm
                    inputProps={{control}} 
                    identificador="nombre" 
                    label="Nombre"
                    placeholder="Nombre Producto"
                    required={true}
                    textUppercase={false}
                    className={`${classResponsiveFormDoubleWidth}`}
                    customError={errors.nombre ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                    style={errors.nombre ? { marginBottom: 0 } : ''}
                />

                <InputForm
                    inputProps={{control, step: 1}} 
                    identificador="orden" 
                    label="Orden"
                    type="number"
                    placeholder="0"
                    required={true}
                    textUppercase={false}
                    className="px-2 col-2"
                    customError={errors.orden ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                    style={errors.orden ? { marginBottom: 0 } : ''}
                />

                <SelectForm
                    inputProps={{control}}
                    identificador="segmentacion" 
                    label="Segmentación Producto"
                    options={segmentacionesProveedores}  
                    showId={false}
                    required={true}
                    className="px-2 col-3"
                    customError={errors.segmentacion ? ERRORFIELDREQUIRED : null}
                    style={errors.segmentacion ? { marginBottom: 0 } : ''}
                />

                <SelectForm
                    inputProps={{control}}
                    identificador="evento" 
                    label="Producto Evento"
                    options={optionsYesNoResponse}  
                    showId={false}
                    required={true}
                    className="px-2 col-2"
                    customError={errors.evento ? ERRORFIELDREQUIRED : null}
                    style={errors.evento ? { marginBottom: 0 } : ''}
                />

                <div className="w-100 row m-0 mb-2 mt-1">
                    <div className="w-50">
                        <div className="w-100 px-1 row m-0">
                            <InputForm
                                identificador="tags" 
                                label="Palabras Clave"
                                placeholder="Palabras Clave Producto"
                                textUppercase={false}
                                value={palabraInput}
                                handleChange={({value}) => setPalabraInput(value)}
                                className="px-2 col-5"
                            />

                            <div className="col-1 mt-2 ml-3 d-flex align-items-center justify-content-center" style={{height: '45px'}}>
                                <Tooltip title="Agregar" aria-label="agregar">
                                    <a onClick={onClickAgregar} className="icon-container-actions d-flex">
                                        <div style={{backgroundColor: Colors.COLOR_BLUE_THEME}}/>
                                        <i style={{color: Colors.COLOR_BLUE_THEME}} className="fas fa-plus fa-2x"/>
                                    </a>
                                </Tooltip>
                            </div>
                        </div>

                        <div className="w-50 px-3 mt-2 overflow-auto" style={{maxHeight: "200px"}}>
                            {palabras.map((el, index) => {
                                return (
                                    <div key={index} className="row m-0 mb-2 py-2 w-75 d-flex align-items-center boxShadow borderRadius5">
                                        <div className="col-8">
                                            <p className="m-0">{el.palabraClave}</p>
                                        </div>
                                        <div className="col-2 d-flex align-items-center">
                                            <Tooltip title="Eliminar" aria-label="eliminar">
                                                <a onClick={() => onClickEliminar(el.palabraClave)} className="icon-container-actions d-flex">
                                                    <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                                                    <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-trash fa-2x"/>
                                                </a>
                                            </Tooltip>
                                        </div>
                                    </div>
                                )
                            })}

                            {palabras.length == 0 && 
                            <div className="row m-0 mb-2 mt-1 py-2 w-100 d-flex align-items-center boxShadow borderRadius5">
                                <div className="col-12 d-flex align-items-center">
                                    <p className="m-0 p-0 text-center">No hay palabras clave asignadas</p>
                                </div>
                            </div>}
                        </div>

                    </div>
                    <div className="w-50">
                        <InputForm
                            inputProps={{control}} 
                            identificador="descripcion" 
                            label="Descripción"
                            placeholder="Descripción Producto"
                            multiline={true}
                            textUppercase={false}
                            className="px-2 w-75"
                        />
                    </div>
                </div>

                <div className="mb-2 d-flex align-items-center" style={{position: "absolute", right: 0, top: 0}}>
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={handleSubmit(onSubmit, () => {})} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>
        </FormProvider>
    )
}

const CategoriasYMarcasComponent = ({dataProducto, categorias = [], marcas = [], categorizacion = []}) => {
    const dispatch = useDispatch();
    const methods = useForm({
        defaultValues: {}
    });
    
    const [dataCategorizacion, setDataCategorizacion] = useState([])
    const { control, setValue, handleSubmit, formState: { errors }, register } = methods;

    useEffect(() => {
        setDataCategorizacion(categorizacion);
    }, [categorizacion])

    const onClickAgregar = (data) => {
        if(!dataCategorizacion.find(d => d.idCategoria == data.categoria && d.idMarca == data.marca)) {
            setDataCategorizacion([...dataCategorizacion, {
                idCategoria: data.categoria,
                idMarca: data.marca,
                nombreCategoria: categorias.find(c => c.id == data.categoria).text,
                nombreMarca: marcas.find(m => m.id == data.marca).text
            }])
        }
    }

    const onClickEliminar = (idCategoria, idMarca) => {
        let index = dataCategorizacion.findIndex(d => d.idCategoria == idCategoria && d.idMarca == idMarca)

        if(index != -1) {
            dataCategorizacion.splice(index, 1);
            setDataCategorizacion([...dataCategorizacion]);
        }
    }

    const onSubmit = async () => {
        try {
            await productosService.updateCategorizacionProducto({idProducto: dataProducto.idProducto, categorizacion: dataCategorizacion})
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Se ha actualizado la categorización del producto' } });
        } catch(error){
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    }

    return (
        <FormProvider {...methods} className="container mx-0 px-0 w-100 mw-100">
            <div className="w-100 px-1 mt-1 row m-0 position-relative">
                <SelectForm
                    inputProps={{control}}
                    identificador="categoria" 
                    label="Categorias"
                    options={categorias}
                    showId={false}
                    required={true}
                    className="px-2 col-3"
                />
                <SelectForm
                    inputProps={{control}}
                    identificador="marca" 
                    label="Marcas"
                    options={marcas}  
                    showId={false}
                    required={true}
                    className="px-2 col-3"
                />

                <div className="ml-3 d-flex align-items-center">
                    <Tooltip title="Agregar" aria-label="agregar">
                        <a onClick={handleSubmit(onClickAgregar, () => {})} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_BLUE_THEME}}/>
                            <i style={{color: Colors.COLOR_BLUE_THEME}} className="fas fa-plus fa-2x"/>
                        </a>
                    </Tooltip>
                </div>

                <div className="w-100 px-3 my-3">
                    {dataCategorizacion.map((el, index) => {
                        return (
                            <div key={index} className="row m-0 mb-2 py-2 w-50 d-flex align-items-center boxShadow borderRadius5">
                                <div className="col-5">
                                    <p className="m-0">{`${el.idCategoria} - ${el.nombreCategoria}`}</p>
                                </div>
                                <div className="col-5">
                                    <p className="m-0">{`${el.idMarca} - ${el.nombreMarca}`}</p>
                                </div>
                                <div className="col-2 d-flex align-items-center">
                                    <Tooltip title="Eliminar" aria-label="eliminar">
                                        <a onClick={() => onClickEliminar(el.idCategoria, el.idMarca)} className="icon-container-actions d-flex">
                                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-trash fa-2x"/>
                                        </a>
                                    </Tooltip>
                                </div>
                            </div>
                        )
                    })}

                    {dataCategorizacion.length == 0 && 
                        <div className="row m-0 mb-2 py-2 w-50 d-flex align-items-center boxShadow borderRadius5">
                            <div className="col-12 d-flex align-items-center">
                                <p className="m-0 p-0 text-center">No hay categorias y marcas asignadas</p>
                            </div>
                        </div>}
                </div>

                <div className="mb-2 d-flex align-items-center" style={{position: "absolute", right: 0, top: 0}}>
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={onSubmit} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>
        </FormProvider>
    )
}

const RestriccionesDeCompraComponent = ({dataProducto, stateTab}) => {
    const dispatch = useDispatch();

    const [dataFecha, setDataFecha] = useState({ fechaInicio: '', fechaFin: '' })
    const [dataHorasActivacion, setDataHorasActivacion] = useState({ horaInicio: '', horaFin: '' })
    const [dataCompra, setDataCompra] = useState({ compraMax: 0, rangoDiasCompra: 0 })
    const [dataHoras, setDataHoras] = useState({ horaInicio: '', horaFin: '' })

    useEffect(() => {
        const fechaInicioActivacion = dataProducto.fechaInicio
        const fechaFinActivacion = dataProducto.fechaFin
        const horaInicio = dataProducto.horaInicioCompra
        const horaFin = dataProducto.horaFinCompra
        
        if(fechaInicioActivacion && fechaInicioActivacion != '0000-00-00 00:00:00' && fechaFinActivacion && fechaFinActivacion != '0000-00-00 00:00:00') {
            setDataFecha({fechaInicio: new Date(fechaInicioActivacion.split(" ")[0].replace(/-/g, "/")), fechaFin: new Date(fechaFinActivacion.split(" ")[0].replace(/-/g, "/"))})
            setDataHorasActivacion({horaInicio: fechaInicioActivacion.split(" ")[1], horaFin: fechaFinActivacion.split(" ")[1]})
        }

        setDataCompra({compraMax: dataProducto.compraMax ?? 0, rangoDiasCompra: dataProducto.rangoDiasCompra ?? 0})

        if(horaInicio && horaInicio != '00:00:00' && horaFin && horaFin != '00:00:00') {
            setDataHoras({horaInicio: dataProducto.horaInicioCompra ?? '', horaFin: dataProducto.horaFinCompra ?? ''})
        }
    }, [])

    const onChangeFecha = ({name, value}) => setDataFecha({fechaInicio: value[0], fechaFin: value[1]})
    const onChangeCompra = ({name, value}) => setDataCompra({...dataCompra, [name]: value})
    const onChangeHora = ({name, value}) => setDataHoras({...dataHoras, [name]: value})
    const onChangeHoraActivacion = ({name, value}) => setDataHorasActivacion({...dataHorasActivacion, [name]: value})

    const eliminarRestriccionFecha = (id) => {
        if(id == 1) {
            setDataFecha({fechaInicio: '', fechaFin: ''})
            setDataHorasActivacion({horaInicio: '', horaFin: ''})
        }
        if(id == 2) setDataCompra({compraMax: 0, rangoDiasCompra: 0})
        if(id == 3) setDataHoras({horaInicio: '', horaFin: ''})
    }

    const onSubmit = async () => {
        const validateRestriccionFecha = [!dataFecha.fechaInicio, !dataFecha.fechaFin, !dataHorasActivacion.horaInicio, !dataHorasActivacion.horaFin]
        
        if(!(validateRestriccionFecha.every(el => el == true) || validateRestriccionFecha.every(el => el == false))) {
            showMessage('Se deben ingresar los cuatro campos del rango de fechas')
            return
        }
        if(!(!dataCompra.compraMax === !dataCompra.rangoDiasCompra)) return showMessage('Se deben ingresar los dos campos de la compra máxima')
        if(!(!dataHoras.horaInicio === !dataHoras.horaFin)) return showMessage('Se deben ingresar los dos campos del rango de horas')

        const dataRestricciones = {
            fechaInicio: (dataFecha.fechaInicio == '' || dataFecha.fechaInicio == null) ? null : (dataFecha.fechaInicio.toISOString().split('T')[0] + ' ' + dataHorasActivacion.horaInicio),
            fechaFin: (dataFecha.fechaFin == '' || dataFecha.fechaFin == null) ? null : (dataFecha.fechaFin.toISOString().split('T')[0] + ' ' + dataHorasActivacion.horaFin),
            compraMax: dataCompra.compraMax,
            rangoDiasCompra: dataCompra.rangoDiasCompra,
            horaInicioCompra: dataHoras.horaInicio == '' ? null : dataHoras.horaInicio,
            horaFinCompra: dataHoras.horaFin == '' ? null : dataHoras.horaFin,
        }

        try {
            if(stateTab == 1) {
                await productosService.updateRestriccionesGeneralProducto({idProducto: dataProducto.idProducto, dataRestricciones})
            }else {
                await productosService.updateRestriccionesEspecificaProducto({idProducto: dataProducto.idProducto, idNegocio: dataProducto.idNegocio, dataRestricciones})
            }
            
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Se han actualizado las restricciones de compra' } });
        } catch(error){
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    }

    const showMessage = (message) => dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message } })

    return (
        <div className="w-100 row m-0 position-relative">
            <div className="w-100">
                <div className="w-100 row m-0 d-flex align-items-center">
                    <CalendarFormRange
                        inputProps={{}}
                        identificador="fechaActivacion" 
                        required={true}  
                        valueIni={dataFecha.fechaInicio}
                        valueFin={dataFecha.fechaFin}
                        handleChange={onChangeFecha}
                        label="Fecha de Activacion Ini - Fin"
                        className="w-auto"
                    />
                    
                    <TimeForm
                        identificador="horaInicio" 
                        label="Hora Inicio Activación"
                        required={true}
                        handleChange={onChangeHoraActivacion}
                        value={dataHorasActivacion.horaInicio}
                        widthContainer="190px"
                        className="px-2"
                    />

                    <TimeForm
                        identificador="horaFin" 
                        label="Hora Fin Activación"
                        required={true}
                        handleChange={onChangeHoraActivacion}
                        value={dataHorasActivacion.horaFin}
                        widthContainer="190px"
                        className="px-2 mr-3"
                    />

                    <Tooltip className="mr-2" title="Utilizar este campo para definir el rango de fechas y horas en las que el producto de evento estará activo">
                        <div style={{position: "relative", background: "white"}}>
                            <div style={{...DIVINFO, backgroundColor: Colors.COLOR_SKY_THEME}}/>
                            <i style={{...ICONINFO,  color: Colors.COLOR_SKY_THEME}} className="fas fa-info fa-2x"/>
                        </div>
                    </Tooltip>

                    <Tooltip title="Eliminar restricción" aria-label="eliminar">
                        <a onClick={() => eliminarRestriccionFecha(1)} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-times fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
                <div className="w-100 row m-0 mt-3 d-flex align-items-center">
                    <InputForm
                        identificador="compraMax" 
                        label="Compra Maxima"
                        placeholder="0"
                        required={true}
                        type="number"
                        value={dataCompra.compraMax}
                        handleChange={onChangeCompra}
                        className="px-2 col-2"
                    />
                    <InputForm
                        identificador="rangoDiasCompra" 
                        label="Rango de Dias Compra"
                        placeholder="0"
                        required={true}
                        type="number"
                        value={dataCompra.rangoDiasCompra}
                        handleChange={onChangeCompra}
                        className="px-2 col-3 mr-3"
                    />

                    <Tooltip className="mr-2" title="Utilizar estos campos para definir que cantidad de productos puede comprar un usuario en un número determinado de días">
                        <div style={{position: "relative", background: "white"}}>
                            <div style={{...DIVINFO, backgroundColor: Colors.COLOR_SKY_THEME}}/>
                            <i style={{...ICONINFO,  color: Colors.COLOR_SKY_THEME}} className="fas fa-info fa-2x"/>
                        </div>
                    </Tooltip>

                    <Tooltip title="Eliminar restricción" aria-label="eliminar">
                        <a onClick={() => eliminarRestriccionFecha(2)} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-times fa-2x"/>
                        </a>
                    </Tooltip>
                </div>

                <div className="w-100 row m-0 mt-3 d-flex align-items-center">
                    <TimeForm
                        identificador="horaInicio" 
                        label="Hora Inicio Compra"
                        required={true}
                        handleChange={onChangeHora}
                        value={dataHoras.horaInicio}
                        className="px-2"
                    />

                    <TimeForm
                        identificador="horaFin" 
                        label="Hora Fin Compra"
                        required={true}
                        handleChange={onChangeHora}
                        value={dataHoras.horaFin}
                        className="px-2 mr-3"
                    />

                     <Tooltip className="mr-2" title="Utilizar estos campos para definir el rango de horas del día en las que se podrá comprar este producto">
                        <div style={{position: "relative", background: "white"}}>
                            <div style={{...DIVINFO, backgroundColor: Colors.COLOR_SKY_THEME}}/>
                            <i style={{...ICONINFO,  color: Colors.COLOR_SKY_THEME}} className="fas fa-info fa-2x"/>
                        </div>
                    </Tooltip>

                    <Tooltip title="Eliminar restricción" aria-label="eliminar">
                        <a onClick={() => eliminarRestriccionFecha(3)} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-times fa-2x"/>
                        </a>
                    </Tooltip>
                </div>

                <div className="mb-2 d-flex align-items-center" style={{position: "absolute", right: 0, top: 0}}>
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={onSubmit} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>
        </div>
    )
}

const ImagenesComponent = ({dataProducto}) => {
    const dispatch = useDispatch();
    
    const [stateAcceptedFilesGeneral, setStateAcceptedFilesGeneral] = useState([]);
    const [stateAcceptedFilesNutricional, setStateAcceptedFilesNutricional] = useState([]);

    const [stateImagenesGeneral, setStateImagenesGeneral] = useState({stateImages: [], stateImagesDelete: []});
    const [stateImagenesNutricional, setStateImagenesNutricional] = useState({stateImages: [], stateImagesDelete: []});


    const {
        acceptedFiles: acceptedFilesGeneral,
        fileRejections: fileRejectionsGeneral,
        getRootProps: getRootPropsGeneral,
        getInputProps: getInputPropsGeneral,
        isDragActive: isDragActiveGeneral,
        isDragAccept: isDragAcceptGeneral,
        isDragReject: isDragRejectGeneral,
        inputRef: inputRefGeneral
    } = useDropzone({ accept: 'image/jpeg, image/png', maxFiles: 1 });

    const {
        acceptedFiles: acceptedFilesNutricional,
        fileRejections: fileRejectionsNutricional,
        getRootProps: getRootPropsNutricional,
        getInputProps: getInputPropsNutricional,
        isDragActive: isDragActiveNutricional,
        isDragAccept: isDragAcceptNutricional,
        isDragReject: isDragRejectNutricional,
        inputRef: inputRefNutricional
    } = useDropzone({ accept: 'image/jpeg, image/png', maxFiles: 1 });

    const stylegeneral = useMemo(() => ({
        ...BASE_STYLE,
        ...(isDragActiveGeneral ? ACTIVE_STYLE : {}),
        ...(isDragAcceptGeneral ? ACCEPT_STYLE : {}),
        ...(isDragRejectGeneral ? REJECT_STYLE : {})
    }), [ isDragActiveGeneral, isDragAcceptGeneral, inputRefGeneral ]);

    const stylenutricional = useMemo(() => ({
        ...BASE_STYLE,
        ...(isDragActiveNutricional ? ACTIVE_STYLE : {}),
        ...(isDragAcceptNutricional ? ACCEPT_STYLE : {}),
        ...(isDragRejectNutricional ? REJECT_STYLE : {})
    }), [ isDragActiveNutricional, isDragAcceptNutricional, inputRefNutricional ]);

    useEffect(() => {
        setStateImagenesGeneral({stateImages: validArray([dataProducto.urlImagen]).slice(), stateImagesDelete: []})
        setStateImagenesNutricional({stateImages: validArray([dataProducto.urlImagenNutricional]).slice(), stateImagesDelete: []})
    }, [])

    useEffect(() => {
        setStateAcceptedFilesGeneral(acceptedFilesItemGeneral)
    }, [acceptedFilesGeneral])

    useEffect(() => {
        setStateAcceptedFilesNutricional(acceptedFilesItemNutricional)
    }, [acceptedFilesNutricional])

    const removeFileGeneral = file  => {
        acceptedFilesGeneral.splice(file, 1);
        setStateAcceptedFilesGeneral(acceptedFilesItemGeneral);
    };

    const removeCurrentGeneral = () => {
        setStateImagenesGeneral({...stateImagenesGeneral, stateImages: []})
    }

    const removeCurrentNutricional = () => {
        setStateImagenesNutricional({...stateImagenesNutricional, stateImages: []})
    }

    const removeFileNutricional = file  => {
        acceptedFilesNutricional.splice(file, 1);
        setStateAcceptedFilesNutricional(acceptedFilesItemNutricional);
    };

    const acceptedFilesItemGeneral = () => {
        return acceptedFilesGeneral.map((file, index) => {
            return (
                <li key={file.path}>
                    <div className="d-flex flex-column align-items-center justify-content-center px-2">
                        <div className="position-relative">
                            <Zoom>
                                <img className="borderImg" src={URL.createObjectURL(file)} style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}/>
                            </Zoom>
                            <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
                                <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                                    <a onClick={() => removeFileGeneral(index)} className="icon-container-actions d-flex mr-0">
                                        <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                        <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                                    </a>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </li>
            )
        })
    };

    const fileRejectionItemsGeneral = fileRejectionsGeneral.map(({ file, errors }) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
            {
                errors?.length > 0 &&
                <li className="font-weight-bold" style={{color: Colors.RED_SWITCH_INACTIVE}} key={errors[0]?.code}>El tipo de archivo debe ser una imagen de tipo image/jpeg o image/png y no debe exceder 1 imagen</li>
            }
        </li>
    ));

    const acceptedFilesItemNutricional = () => {
        return acceptedFilesNutricional.map((file, index) => {
            return (
                <li key={file.path}>
                    <div className="d-flex flex-column align-items-center justify-content-center px-2">
                        <div className="position-relative">
                            <Zoom>
                                <img className="borderImg" src={URL.createObjectURL(file)} style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}/>
                            </Zoom>
                            <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
                                <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                                    <a onClick={() => removeFileNutricional(index)} className="icon-container-actions d-flex mr-0">
                                        <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                        <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                                    </a>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </li>
            )
        })
    };

    const fileRejectionItemsNutricional = fileRejectionsNutricional.map(({ file, errors }) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
            {
                errors?.length > 0 &&
                <li className="font-weight-bold" style={{color: Colors.RED_SWITCH_INACTIVE}} key={errors[0]?.code}>El tipo de archivo debe ser una imagen de tipo image/jpeg o image/png y no debe exceder 1 imagen</li>
            }
        </li>
    ));

    const onSubmit = async () => {
        try {
            const imageGeneralTemp = validArray(acceptedFilesGeneral).slice()[0]

            if(imageGeneralTemp){
                const nombreImg = `proGen_${dataProducto.idProveedor}_${dataProducto.idProducto}_${getCurrentTime()}.png`

                const imageUpload = new File ([imageGeneralTemp], nombreImg)
                let resGeneral = await productosService.saveImageGeneralProducto({ 
                    file: imageUpload,
                    nombreImg,
                    idProducto: dataProducto.idProducto, 
                    idProveedor: dataProducto.idProveedor
                })
                
                setStateImagenesGeneral({stateImages: [resGeneral.data], stateImagesRejection: []})

                acceptedFilesGeneral.pop()
                setStateAcceptedFilesGeneral(acceptedFilesItemGeneral)
            }

            const imageNutricionalTemp = validArray(acceptedFilesNutricional).slice()[0]

            if(imageNutricionalTemp){
                const nombreImg = `proNut_${dataProducto.idProveedor}_${dataProducto.idProducto}_${getCurrentTime()}.png`

                const imageUploadNutricional = new File ([imageNutricionalTemp], nombreImg)
                let resNutricional = await productosService.saveImageNutricionalProducto({ 
                    file: imageUploadNutricional, 
                    nombreImg,
                    idProducto: dataProducto.idProducto, 
                    idProveedor: dataProducto.idProveedor
                })
    
                setStateImagenesNutricional({stateImages: [resNutricional.data], stateImagesRejection: []})
    
                acceptedFilesNutricional.pop()
                setStateAcceptedFilesNutricional(acceptedFilesItemNutricional)
            }

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Imagenes guardadas correctamente' } });
        } catch (error) {
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    };
    
    return (
        <div className="w-100 row pt-4 m-0 position-relative">
            <div className="w-50 px-3">
                <strong>Imagen principal</strong>
                <div className="mt-2 mb-4 borderUploadDocument px-3">
                    <div className="py-2 px-4 d-flex justify-content-center align-items-center mt-2 borderBottomDashed">
                        {stateImagenesGeneral.stateImages?.length === 0 ?
                            <h4 className="m-0 vertical-align-center">No hay una imagen guardada</h4>
                            :
                            <div className='w-100'>
                                <h4 className="font-weight-bold fontSizeDropCurrentFiles">Imagen actual</h4>
                                <ul id="currentFiles">
                                    <li>
                                        <div className="d-flex flex-column align-items-center justify-content-center px-2">
                                            <div className="position-relative">
                                                <Zoom>
                                                    <img 
                                                        className="borderImg" 
                                                        src={stateImagenesGeneral.stateImages[0]} 
                                                        style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}
                                                    />
                                                </Zoom>
                                                <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
                                                    <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                                                        <a onClick={() => removeCurrentGeneral()} className="icon-container-actions d-flex mr-0">
                                                            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                                            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                                                        </a>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                    <div className="mt-4 text-center minHeight200 d-flex flex-column justify-content-center cursor-pointer boxShadow borderRadius5" {...getRootPropsGeneral({stylegeneral})}>
                        <input {...getInputPropsGeneral()} />
                        <p className="font-weight-bold mb-1" style={{color: Colors.DARK_GRAY}}>Arrastra hasta aqui las imagenes que desees o haz click aqui para seleccionarlas</p>
                        <em className="font-weight-bold" style={{color: Colors.DARK_GRAY}}>(Solo *.jpeg and *.png imagenes son aceptadas)</em>
                    </div>
                
                    <aside className="px-3 mb-4">
                        {
                            acceptedFilesGeneral?.length > 0 &&
                            <>
                                <h4 className="mt-3 font-weight-bold fontSizeDropFilesAccepted">Imágenes aceptadas</h4>
                                <ul id="acceptedFiles">{stateAcceptedFilesGeneral}</ul>
                            </>
                        }
                        {
                            fileRejectionsGeneral?.length > 0 &&
                            <>
                                <h4 className="my-2 font-weight-bold fontSizeDropFilesRejected">Imágenes rechazadas</h4>
                                <ul id="rejectedFiles">{fileRejectionItemsGeneral}</ul>
                            </>
                        }
                    </aside>
                </div>
            </div>
            
            <div className="w-50 px-3">
                <strong>Imagen nutricional</strong>
                <div className="my-2 borderUploadDocument px-3">
                    <div className="py-2 px-4 d-flex justify-content-center align-items-center mt-2 borderBottomDashed">
                        {stateImagenesNutricional.stateImages?.length === 0 ?
                            <h4 className="m-0 vertical-align-center">No hay una imagen guardada</h4>
                            :
                            <div className='w-100'>
                                <h4 className="font-weight-bold fontSizeDropCurrentFiles">Imagen actual</h4>
                                <ul id="currentFiles">
                                    <li>
                                        <div className="d-flex flex-column align-items-center justify-content-center px-2">
                                            <div className="position-relative">
                                                <Zoom>
                                                    <img 
                                                        className="borderImg" 
                                                        src={stateImagenesNutricional.stateImages[0]} 
                                                        style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}
                                                    />
                                                </Zoom>
                                                <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
                                                    <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                                                        <a onClick={() => removeCurrentNutricional()} className="icon-container-actions d-flex mr-0">
                                                            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                                            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                                                        </a>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                    <div className="mt-2 text-center minHeight200 d-flex flex-column justify-content-center cursor-pointer boxShadow borderRadius5" {...getRootPropsNutricional({stylenutricional})}>
                        <input {...getInputPropsNutricional()} />
                        <p className="font-weight-bold mb-1" style={{color: Colors.DARK_GRAY}}>Arrastra hasta aqui las imagenes que desees o haz click aqui para seleccionarlas</p>
                        <em className="font-weight-bold" style={{color: Colors.DARK_GRAY}}>(Solo *.jpeg and *.png imagenes son aceptadas)</em>
                    </div>

                    <aside className="px-3 mb-3">
                        {
                            acceptedFilesNutricional?.length > 0 &&
                            <>
                                <h4 className="mt-3 font-weight-bold fontSizeDropFilesAccepted">Imágenes aceptadas</h4>
                                <ul id="acceptedFiles">{stateAcceptedFilesNutricional}</ul>
                            </>
                        }
                        {
                            fileRejectionsNutricional?.length > 0 &&
                            <>
                                <h4 className="my-2 font-weight-bold fontSizeDropFilesRejected">Imágenes rechazadas</h4>
                                <ul id="rejectedFiles">{fileRejectionItemsNutricional}</ul>
                            </>
                        }
                    </aside>
                </div>
            </div>

            <div className="mb-2 d-flex align-items-center" style={{position: "absolute", right: 0, top: 0}}>
                <Tooltip title="Guardar" aria-label="guardar">
                    <a onClick={onSubmit} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>
            </div>
        </div>
    )
}

const InformacionBasicaEspecificaComponent = ({dataProducto}) => {
    const dispatch = useDispatch();
    const methods = useForm({
        defaultValues: {
            valorProducto: dataProducto.valorProducto,
            inventario: dataProducto.inventario,
            iva: dataProducto.iva,
            estadoApp: dataProducto.estadoAplicacion,
            estadoDistribuidor: dataProducto.estado,
            porcentajeComparacion: dataProducto.porcentajeComparacion,
            porcentajeDistribuidor: dataProducto.porcentajeDistribuidor,
            precioMaestro: dataProducto.precioMaestro
        }
    });

    const { control, setValue, handleSubmit, getValues, formState: { errors }, register } = methods;
    const [usaPorcentajeDist, setUsaPorcentajeDist] = useState(Boolean(dataProducto.usaPorcentajeDistribuidor))

    const onSubmit = async (data) => {
        try {
            data.usaPorcentajeDistribuidor = Number(usaPorcentajeDist)
            data.porcentajeComparacion = usaPorcentajeDist ? dataProducto.porcentajeComparacion : data.porcentajeComparacion

            await productosService.updateInformacionBasicaEspecifica({idProducto: dataProducto.idProducto, idNegocio: dataProducto.idNegocio, data})

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Información actualizada correctamente' } });
        } catch(error){
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    }

    const getColorShadow = () => {
        if(dataProducto.precioMaestro == 0) return "white"

        const porcentaje = usaPorcentajeDist ? getValues('porcentajeDistribuidor') : getValues('porcentajeComparacion')

        if(Number(getValues('valorProducto')) < Number(dataProducto.precioMaestro) * (1 - (Number(porcentaje) / 100))) return Colors.ROJO_PASTEL
        if(Number(getValues('valorProducto')) > Number(dataProducto.precioMaestro) * (1 + (Number(porcentaje) / 100))) return Colors.GREEN_SWITCH_ACTIVE
        
        return "white"
    }

    return (
        <FormProvider {...methods}>
            <div className="w-100 row m-0 position-relative">
                <InputForm
                    inputProps={{control}}
                    identificador="valorProducto" 
                    label="Precio"
                    type="number"
                    placeholder=""
                    required={true}
                    textUppercase={false}
                    className="px-2 col-2"
                    customError={errors.valorProducto ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                    style={{
                        marginBottom: errors.valorProducto ? 0 : 'auto', 
                        borderRadius: 5,
                        borderBottom: `2px solid ${getColorShadow()}`
                    }}
                />

                <InputForm
                    inputProps={{control, step: 1, max: 100}} 
                    identificador="iva" 
                    label="Porcentaje IVA"
                    type="number"
                    placeholder="0"
                    required={true}
                    textUppercase={false}
                    className="px-2 col-2"
                    customError={errors.iva ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                    style={errors.iva ? { marginBottom: 0 } : ''}
                />

                <SelectForm
                    inputProps={{control}}
                    identificador="estadoApp" 
                    label="Estado en la aplicación"
                    options={optionsEstadosSelect}  
                    showId={false}
                    required={true}
                    className="px-2 col-3"
                    customError={errors.estadoApp ? ERRORFIELDREQUIRED : null}
                    style={errors.estadoApp ? { marginBottom: 0 } : ''}
                />

                <SelectForm
                    inputProps={{control}}
                    identificador="estadoDistribuidor" 
                    label="Estado en el distribuidor"
                    options={optionsEstadosSelect}  
                    showId={false}
                    required={true}
                    className="px-2 col-3"
                    customError={errors.estadoDistribuidor ? ERRORFIELDREQUIRED : null}
                    style={errors.estadoDistribuidor ? { marginBottom: 0 } : ''}
                />

                <div className="w-100">
                    <InputForm
                        inputProps={{control}} 
                        identificador="precioMaestro" 
                        label="Precio maestro"
                        placeholder=""
                        textUppercase={false}
                        className="px-2 col-2"
                        disabled={true}
                    />

                    <InputForm
                        inputProps={{control}} 
                        identificador="inventario" 
                        label="Inventario"
                        placeholder="1"
                        required={true}
                        textUppercase={false}
                        className="px-2 col-2"
                        customError={errors.inventario ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                        style={errors.inventario ? { marginBottom: 0 } : ''}
                    />
                </div>

                <div className="w-100 mt-1">
                    <InputForm
                        inputProps={{control, step: 1, max: 100}}
                        identificador="porcentajeComparacion"
                        label="Porcentaje de comparación"
                        type="number"
                        placeholder="0"
                        required={Boolean(!usaPorcentajeDist)}
                        disabled={Boolean(usaPorcentajeDist)}
                        textUppercase={false}
                        className="px-2 col-3"
                        customError={errors.porcentajeComparacion ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                        style={errors.porcentajeComparacion ? { marginBottom: 0 } : ''}
                    />

                    <InputForm
                        inputProps={{control, step: 1, max: 100}}
                        identificador="porcentajeDistribuidor"
                        label="Porcentaje de comparación distribuidor"
                        type="number"
                        placeholder="0"
                        required={false}
                        textUppercase={false}
                        disabled={true}
                        className="px-2 col-3"
                        customError={errors.porcentajeDistribuidor ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                        style={errors.porcentajeDistribuidor ? { marginBottom: 0 } : ''}
                    />

                    <div className="px-2 ml-2">
                        <CheckBox
                            identificador="usaPorcentajeDistribuidor"
                            value={usaPorcentajeDist}
                            label="Usar porcentaje de distribuidor"
                            styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem", userSelect: "none"}}
                            onChange={({name, checked}) => setUsaPorcentajeDist(checked)}
                        />
                    </div>
                </div>

                <div className="mb-2 d-flex align-items-center" style={{position: "absolute", right: 0, top: 0}}>
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={handleSubmit(onSubmit, () => {})} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>
        </FormProvider>
    )
}

const InformacionEspecifica = ({ data: { dataProducto }, stateTab, showHelp, setShowHelp }) => {
    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="w-100 px-2">
                <div className={`containerMessageHelpPro boxShadow ${showHelp ? "containerHelpProOpen" : ""}`} style={{ backgroundColor: Colors.BLUE_LOW }}>
                    {stateTab == 1 ? 
                        <span>Los campos que se modifiquen en este apartado se verán reflejados en todos los productos que tengan asignado como código de producto <strong className="ml-2">{dataProducto.idProducto}</strong>.</span> 
                    : 
                        <span>Los campos que se modifiquen en este apartado se verán reflejados solo en el producto actualmente seleccionado.</span>}
        
                    <div>
                        <button onClick={() => setShowHelp(false)}>
                            <i style={{color: Colors.COLOR_AMOVIL_BLUE_DARK}} className="far fa-times fa-1x"/>
                        </button>
                    </div>
                </div>

                <ContainerSectionModal label="Información Básica" 
                    component={
                        <InformacionBasicaEspecificaComponent 
                            dataProducto={dataProducto}
                        />
                    }/>
                <ContainerSectionModal label="Restricciones de compra" 
                    component={
                        <RestriccionesDeCompraComponent 
                            dataProducto={dataProducto}
                            stateTab={stateTab}
                        />
                    }/>
            </div>
        </div>
    )
}

const FormProductosCRUD = ({properties}) => {
    const { data: { dataProducto, segmentacionesProveedores, categorias, marcas, categorizacion, tags } } = properties;
    
    const [stateTab, setStateTab] = useState(1)
    const [showHelp, setShowHelp] = useState(false)
    const [timer, setTimer] = useState(null)
    
    useEffect(() => {
        setShowHelp(false)
        clearTimeout(timer)
    }, [stateTab])

    const onClickShowInfo = () => {
        setShowHelp(true)
        clearTimeout(timer)

        setTimer(setTimeout(() => {
            setShowHelp(false)
        }, 6000))
    }

    return (
        <div className="p-2">
            <div className="w-100 row m-0 mb-4">
                <div className="row m-0" style={{width: "90%"}}>
                    <div className="mr-5">
                        <span className="mr-2">Proveedor:</span>
                        <strong>{dataProducto.idProveedor} - {dataProducto.nombreProveedor}</strong>
                    </div>
                    <div className="mr-5">
                        <span className="mr-2">Negocio:</span>
                        <strong>{dataProducto.idNegocio} - {dataProducto.nombreNegocio}</strong>
                    </div>
                    <div className="mr-5">
                        <span className="mr-2">Codigo de producto:</span>
                        <strong>{dataProducto.idProducto}</strong>
                    </div>
                </div>

                <div className="d-flex justify-content-end" style={{width: "10%"}}>
                    <Tooltip title="Mostar ayuda" aria-label="Mostar ayuda">
                        <a onClick={onClickShowInfo} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
                            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-info fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>

            <div className="d-flex align-items-center">
                <TabsClassic tabs={[
                    {
                        id: 1,
                        label: "Infomación general del producto",
                        content: <InformacionGeneral showHelp={showHelp} setShowHelp={setShowHelp} stateTab={stateTab} data={{
                            dataProducto, 
                            segmentacionesProveedores, 
                            categorizacion,
                            categorias,
                            marcas,
                            tags
                        }}/>
                    },
                    {
                        id: 2,
                        label: "Información especifica del producto",
                        content: <InformacionEspecifica showHelp={showHelp} setShowHelp={setShowHelp} stateTab={stateTab} data={{
                            dataProducto
                        }}/>
                    }
                ]} initialState={1} stateTab={setStateTab}/>
            </div>
        </div>
    )
};

export default FormProductosCRUD;
